import { LexbeDoc } from '@models/doc.model';
import { LexbeCodingTextBox } from '@models/lexbe-coding-text-box.model';
import { LexbeCodingCheckBox } from '@models/lexbe-coding-check-box.model';
import { Injectable } from '@angular/core';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';

@Injectable({
	'providedIn': 'root'
})
export class CustomCodingFieldsValuesManager {
	public ccfTextBoxes: Map<string, LexbeCodingTextBox>;
	public ccfCheckBoxes: Map<string, LexbeCodingCheckBox>;

	constructor(private docViewerStore: DocViewerStore) {
		this.ccfTextBoxes = new Map<string, LexbeCodingTextBox>();
		this.ccfCheckBoxes = new Map<string, LexbeCodingCheckBox>();
		this.docViewerStore.updateState((currentState) => {
			currentState.hasUnsavedCustomCodingChanges = false;
			return currentState;
		});
	}

	public reset(): void {
		this.ccfTextBoxes = new Map<string, LexbeCodingTextBox>();
		this.ccfCheckBoxes = new Map<string, LexbeCodingCheckBox>();
		this.docViewerStore.updateState((currentState) => {
			currentState.hasUnsavedCustomCodingChanges = false;
			return currentState;
		});
	}

	public findCcfTextBox(document: LexbeDoc, childId: string): LexbeCodingTextBox {
		if (this.ccfTextBoxes.has(childId)) return this.ccfTextBoxes.get(childId);

		const child = new LexbeCodingTextBox();

		if (!document) return child;

		const match = document.customCodingFields.find(f => f.fieldId === childId);

		child.fieldId = childId;
		child.docId = document.docId;
		child.text = match ? (match as LexbeCodingTextBox).text : '';
		this.ccfTextBoxes.set(childId, child);

		return child;
	}

	public findCcfCheckBox(document: LexbeDoc, childId: string): LexbeCodingCheckBox {
		if (this.ccfCheckBoxes.has(childId)) return this.ccfCheckBoxes.get(childId);

		const child = new LexbeCodingCheckBox();

		if (!document) return child;

		const match = document.customCodingFields.find(f => f.fieldId === childId);

		child.fieldId = childId;
		child.docId = document.docId;
		child.checked = match ? (match as LexbeCodingCheckBox).checked : false;
		this.ccfCheckBoxes.set(childId, child);

		return child;
	}

	/** Replaces the custom coding fields in the current doc with fields that have values from the right panel. */
	public populateDoc(document: LexbeDoc) {
		document.customCodingFields = [];
		this.ccfTextBoxes.forEach(textbox => document.customCodingFields.push(textbox));
		this.ccfCheckBoxes.forEach(checkbox => document.customCodingFields.push(checkbox));
	}
}

